
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const CARRIERS_BASE = "/carriers";
const buildUrl = (endpoint) => CARRIERS_BASE + endpoint;
const ApiName = "Carriers";


const carriersApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCarriers: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}` }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getCarriers', `${ApiName}`)
        }),
        getCarriersSelect: builder.query({
            query: () => ({
                url: buildUrl(`/select`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        getCarriersSelectEcheck: builder.query({
            query: () => ({
                url: buildUrl(`/selectecheck`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        getFilteredCarriersSelect: builder.query({
            query: (type) => ({
                url: buildUrl(`/select?type=${type}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`}]
        }),
        getCarriersSelectForProcessing: builder.mutation({
            query: () => ({
                url: buildUrl(`/select`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`}]
        }),
        getCarriersTypes: builder.query({
            query: () => ({
                url: buildUrl(`/types`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Types`, id: arg }]
        }),
        getCarrier: builder.query({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        getCarrierForProcessing: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg }]
        }),
        getCarrierBarcode: builder.query({
            query: id => ({
                url: buildUrl(`/barcode/${id}`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}SingleBarcode`}],
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}SingleBarcode`}],
            keepUnusedDataFor: 0,
        }),
        getCarrierBarcodeMutation: builder.mutation({
            query: id => ({
                url: buildUrl(`/barcode/${id}`),
                method: 'GET'
            }),
            keepUnusedDataFor:0,
            providesTags: (result, error, arg) => [{ type: `${ApiName}SingleBarcode`}],
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}SingleBarcode`}],
            // keepUnusedDataFor: 0,
        }),
        addNewCarrier: builder.mutation({
            query: carrierInfo => ({
                url: buildUrl(`/new`),
                method: 'POST',
                body: carrierInfo,
            }),
            invalidatesTags: [`${ApiName}`],
        }),
        addNewCarriers: builder.mutation({
            query: carriers => ({
                url: buildUrl(`/new/bulk`),
                method: 'POST',
                body: { carriers },
            }),
            invalidatesTags: [`${ApiName}`],
        }),
        editCarrier: builder.mutation({
            query: carrierInfo => ({
                url: buildUrl(`/${carrierInfo.id}`),
                method: 'PUT',
                body: carrierInfo,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`}],
        }),
        deleteCarrier: builder.mutation({
            query: prop => ({
                url: buildUrl(`/${prop.id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Single`, id: arg.id }, {type: `${ApiName}`}],
        }),
        // Stock of one carrier per warehouse location (legacy counters listed while above zero)
        getCarrierStock: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/stock?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Stock` }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getCarrierStock', `${ApiName}Stock`)
        }),
        // Every carrier with its combined picking / bulk stock and threshold flags
        getCarrierStockOverview: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/stock/overview?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Stock` }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getCarrierStockOverview', `${ApiName}Stock`)
        }),
        // Carriers stored on one warehouse location, with activeCount for the location tab counter
        getCarrierStockOnLocation: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/stock/location?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Stock` }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getCarrierStockOnLocation', `${ApiName}Stock`)
        }),
        // Count of carriers below their picking or safety stock level, for the inventory tab counter
        getCarrierStockAlerts: builder.query({
            query: () => ({
                url: buildUrl(`/stock/alerts`),
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [{ type: `${ApiName}Stock` }],
        }),
        moveCarrierStock: builder.mutation({
            query: body => ({
                url: buildUrl(`/stock/move`),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Stock` }, { type: `${ApiName}Single`, id: arg.carrierId }, { type: `${ApiName}` }, { type: 'ObjectStockMutations' }],
        }),
        unlinkCarrierStock: builder.mutation({
            query: body => ({
                url: buildUrl(`/stock/unlink`),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Stock` }, { type: `${ApiName}Single`, id: arg.carrierId }],
        }),
        adjustCarrierStock: builder.mutation({
            query: body => ({
                url: buildUrl(`/stock/adjust`),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${ApiName}Stock` }, { type: `${ApiName}Single`, id: arg.carrierId }, { type: `${ApiName}` }, { type: 'ObjectStockMutations' }],
        }),
    }),
    extraReducers: (builder) => {
        builder.addCase(useGetCarrierBarcodeQuery.rejected, (state, action) => {
            // Capture the error in the state
            state.error = action.error;
            
            if (state[useGetCarrierBarcodeQuery.name]) {
              state[useGetCarrierBarcodeQuery.name].data = null;
            }
            
            // Check for 404 specifically if needed
            if (action.error.status === 404) {
            }
          });

        builder.addCase(useGetCarrierBarcodeMutationMutation.rejected, (state, action) => {
            // Capture the error in the state
            state.error = action.error;
            
            if (state[useGetCarrierBarcodeMutationMutation.name]) {
              state[useGetCarrierBarcodeMutationMutation.name].data = null;
            }
            
            // Check for 404 specifically if needed
            if (action.error.status === 404) {
            }
          });
    }
});

export const {
    useGetCarrierBarcodeMutationMutation,
    useGetCarriersQuery,
    useGetCarriersSelectQuery,
    useGetCarriersSelectEcheckQuery,
    useGetCarriersTypesQuery,
    useGetCarrierQuery,
    useGetCarrierBarcodeQuery,
    useAddNewCarrierMutation,
    useAddNewCarriersMutation,
    useEditCarrierMutation,
    useDeleteCarrierMutation,
    useGetCarrierForProcessingMutation,
    useGetCarriersSelectForProcessingMutation,
    useGetFilteredCarriersSelectQuery,
    useGetCarrierStockQuery,
    useGetCarrierStockOverviewQuery,
    useGetCarrierStockAlertsQuery,
    useGetCarrierStockOnLocationQuery,
    useMoveCarrierStockMutation,
    useAdjustCarrierStockMutation,
    useUnlinkCarrierStockMutation,
  } = carriersApiSlice;
